module.exports = __webpack_public_path__ + "static/media/BFCM-2021-offer.ddd24d32.png";